import DomainEntity from '@/models/DomainEntity'

export default class StrategyCommunications extends DomainEntity {
  static get collectionName() {
    return 'strategycommunications/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      add: [],
      update: {},
      delete: [],
    }
  }
}
